import { HttpClient } from '@angular/common/http';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { DataTableDirective } from 'angular-datatables';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { DataEntryDashboardModel } from '../../shared/models/DataEntryDashboardModel';
import { DataTablesResponse } from '../../shared/models/datatables-response';
import { BrokerSelecttionModel } from '../../shared/models/SavePropertyInputModel';
import { CommonService } from '../../shared/providers/common.service';
import { LoaderService } from '../../shared/providers/loader.service';
import { PropertyManagementService } from '../../shared/providers/property-management.service';
import { ToastService } from '../../shared/providers/toast.service';
import { ValidationService } from '../../shared/providers/validation.service';

export interface IHourModel {

  DataEntryStaffid?: number;
  Hours?: number;
  DateFromRange: Date;
  DateToRange: Date;
  CreatedUser: number;
}

@Component({
  selector: 'app-data-entry-dashboard',
  templateUrl: './data-entry-dashboard.component.html',
  styleUrls: ['./data-entry-dashboard.component.css']
})

export class DataEntryDashboardComponent implements OnInit {
  protected readonly BASE_URL: string = environment.base_url;
  dtOptions: {};
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;

  constructor(public Validation: ValidationService, public authService: AuthenticationService, private http: HttpClient, private modalService: BsModalService, private _commonService: CommonService,
    private _propertyManagementService: PropertyManagementService, protected loaderService: LoaderService, private _toastService: ToastService) { }

  ngOnInit(): void {
    this.user = this.authService.user;
    this.getCurrentWeekStartDateEndDate();
    this.loadData();
  }

  modalRefInquiry: BsModalRef;
  dataentrystafflst: BrokerSelecttionModel[] = [];
  userValid: boolean = false;
  isSubmit: boolean = false
  hourInputModel = {} as IHourModel;
  users: DataEntryDashboardModel[];
  user: any;
  rowCount = 0;
  dateFromRange: Date;
  dateToRange: Date;
  IsLoading = true;
  openHourlyLimit(template: TemplateRef<any>) {
    this.loaderService.display(true);
    this.modalRefInquiry = this.modalService.show(template, { class: 'panlestyle' });
    this.GetDataEntryStaffsList();
    this.loaderService.display(false);
  }

  GetDataEntryStaffsList() {
    this._propertyManagementService.getDataEntryStaffs().subscribe(response => {
      this.dataentrystafflst = response;
      this.hourInputModel.DataEntryStaffid = 0;
    });
  }

  onClose() {
    this.modalRefInquiry.hide();
    this.hourInputModel.DataEntryStaffid = 0;
    this.hourInputModel.Hours = 0;
    this.hourInputModel.DateFromRange = null;
    this.hourInputModel.DateToRange = null
    this.isSubmit = false
  }

  saveHours() {
    let valid = true;
    this.isSubmit = true;
    this.hourInputModel.CreatedUser = this.user.Id;
    if (this.Validation.IsinValid(this.hourInputModel.Hours) || this.Validation.IsinValid(this.hourInputModel.DataEntryStaffid)) {
      valid = false;
    }
    if (valid) {
      this._commonService.saveHourLimit(this.hourInputModel).subscribe(response => {
        if (response) {
          this._toastService.addToast({ title: 'Success', msg: 'Hour Limit Saved Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
          this.onClose();
          this.dtElement.dtInstance.then(x => x.draw());
        }
        else {
          this._toastService.addToast({ title: 'Error Occurred', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
          this.onClose();
        }
      });
    }
  }

  onSearch(text: string) {
    ;
    this.dtElement.dtInstance.then(x => x.search(text).draw());
  }

  loadData() {
    const that = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      "pageLength": 50,
      "order": [],
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        this.IsLoading = true;
        this.users = [];
        $(".dataTables_paginate.paging_full_numbers").hide();
        const filter =
        {
          UserId: this.user.Id,
          DateFrom: this.dateFromRange,
          DateTo: this.dateToRange
        }
        dataTablesParameters.Extra_param = filter;

        let url = this.BASE_URL + '/common/DataEntryDashboard/';
        const httpHeader = this.Validation.GetAuthHeader();
        that.http
          .post<DataTablesResponse>(
            url,
            dataTablesParameters, httpHeader
          ).subscribe(resp => {
            that.users = resp.data ? resp.data : [];
            if (this.rowCount === 0) {
              this.rowCount = resp.recordsTotal;
            }
            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
              if (resp.data.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show();
              }
              $(".paginate_button.first,.paginate_button.last").hide();
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
              $(".dataTables_paginate.paging_full_numbers").hide();
            }
            this.IsLoading = false;
          });
      },
      columns: [{ data: 'Name', orderable: false },
      { data: 'WeeklyHourLimit', orderable: false },
      { data: 'ProeprtiesRejected', orderable: false },
      { data: 'PropertiesApproved', orderable: false },
      { data: 'PropertiesCreated', orderable: false },
      { data: 'PropertiesVerified', orderable: false },
      { data: 'PropertiesModified', orderable: false },
      { data: 'PropertiesUnderContract', orderable: false },
      { data: 'PropertiesNotAvailable', orderable: false },
      { data: 'PropertiesAvailable', orderable: false },
      { data: 'PropertiesViewed', orderable: false }
      ]
    };
  }

  onSearchBtn() {
    this.dtElement.dtInstance.then(x => x.draw());
  }

  onResetBtn() {
    this.getCurrentWeekStartDateEndDate();
  }

  getCurrentWeekStartDateEndDate() {
    //Date Range will be from sunday to saturday
    var curr = new Date; // get current date
    var first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
    var last = first + 6; // last day is the first day + 6

    var firstday = new Date(curr.setDate(first));
    var lastday = new Date(curr.setDate(last));
    this.dateFromRange = firstday;
    this.dateToRange = lastday;
  }

  getSelectedUserHourLimit() {
    this._commonService.getSelecetedUserHourLimit(this.hourInputModel.DataEntryStaffid).subscribe(response => {
      if (response) {
        this.hourInputModel.Hours = Number(response);
      }
      else {
        this.hourInputModel.Hours = null;
      }
    });
  }
}
